<template>
  <button type="button" :class="btn.className" :disabled="isDisabled"
    @click="$emit('btnClick')">{{btn.label}}</button>
</template>

<script>
export default {
    name: 'Button',
    props: {
        isDisabled: {
            type: Boolean,
            default: false
        },
        btn: {
            type: Object,
            default: ()=>{
                return {
                    label: 'Button',
                    className: 'default'
                }
            }
        },
    }
}
</script>


<style lang="scss" scoped>
$color-lightgray: #f5f5f5;
$color-point: #ff6900;

button {
    padding: 16px 24px;
    background-image: none;
    border: 1px solid $color-lightgray;
    color: $color-lightgray;
    background-color: transparent;
    text-align: center;
    cursor: pointer;

    margin-right: 8px;
    border-radius: 8px;

    &:focus {
        outline:none;
    }

    &:last-child {
        margin-right: 0
    }


    &.default{
        color: #ffffff;
        background-color: $color-point;
        border: 1px solid $color-point;
    }
     &:disabled, &.disabled {
        background-color: #DCDDDD !important;
        border: 1px solid #DCDDDD !important;
        color: #ffffff;//$form-color-disabled !important;
        // color: lighten($form-color-disabled , 80%)! important;
        // /darken
    }  

}
</style>